var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiriFullLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 42,
    viewBox: "0 0 138 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 8.80029C63.955 8.80029 60.9469 10.8367 59.7044 13.9424L52 33.2002H58L64.6443 16.5765C65.6027 14.1785 68.9972 14.1785 69.9557 16.5765L76.6 33.2002H82.6L74.8955 13.9424C73.6531 10.8367 70.645 8.80029 67.3 8.80029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7996 8.80029V33.2001H88.5996V8.80029H94.7996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.358 8.80029C119.521 8.80029 123.801 12.937 123.801 18.1003C123.801 21.5759 121.81 24.6575 118.995 26.2687L118.893 26.3265L118.985 26.4263C120.703 28.3086 121.948 30.629 122.534 33.2003L116.093 33.2002C114.777 29.903 112.187 27.4015 108.24 27.4015L108.09 27.4003H106.601V21.4003H114.358C116.221 21.4003 117.801 19.9634 117.801 18.1003C117.801 16.2586 116.255 14.8345 114.422 14.8003H114.358H102.801V8.80029H114.358Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.001 8.80029V33.2001H131.801V8.80029H138.001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0ZM21 1.27273C10.1049 1.27273 2.86943 9.13935 2.86943 20.0344C2.86943 26.3326 7.69724 28.7785 12.2925 32.3903C15.6465 35.0265 17.9781 38.7961 22.575 38.7961C33.4701 38.7961 32.6383 31.1935 36.1165 21C38.1794 14.9545 38.2871 10.1164 34.3897 6.51262C30.8724 3.26023 26.1683 1.27273 21 1.27273Z",
    fill: "url(#paint0_linear_330_1302)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0004 11.1367L30.864 21.0004L21.0004 30.864L11.1367 21.0004L21.0004 11.1367Z",
    fill: "url(#paint1_linear_330_1302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_1302",
    x1: 5.01175,
    y1: -3.52737e-7,
    x2: 44.9415,
    y2: 48.4914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161C27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_330_1302",
    x1: 21.0004,
    y1: 11.1367,
    x2: 30.864,
    y2: 29.3865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015A60"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiriFullLogo);
export default __webpack_public_path__ + "static/media/airi-full-logo.62daabca9a941ecfdd4c160e824d6e34.svg";
export { ForwardRef as ReactComponent };